"use strict";

var Url = require("url");

var hsHost = process.env.HS_DOMAIN;
var hfHost = process.env.HF_DOMAIN;
var cdnHost = process.env.CDN_URL;

// find something like dev-hellosign
var prefix = hsHost.match(/(\w+-)\w+.com/);
if (prefix) prefix = prefix[1];

var subdomain = hsHost.match(/^(\w+)/)[1];

module.exports = {
    "hfCdn": cdnHost,
    "hsCdn": cdnHost,
    "urlHelperUrl": "\/\/" + subdomain + "." + (prefix || "") + "__site__.com",
    "HfSites": {
        "SITE_CODE_HF": "hellofax",
        "SITE_CODE_HS": "hellosign",
        "SITE_CODES": ["F", "S"]
    },
    "HfConstants": {
        "csrfFieldName": "_csrf_token",
        "supportPhoneNumber": "(415) 766-0273",
        "supportEmail": {
            "hellosign": "support@hellosign.com",
            "hellofax": "support@hellofax.com"
        },
        "team_fax_lines": {
            "STATUS_CODES": {
                "STATUS_CODE_ACTIVE": "A",
                "STATUS_CODE_PORTING_DENIED": "D",
                "STATUS_CODE_PORTING_LOA_COMPLETED": "4",
                "STATUS_CODE_PORTING_ACCEPTED": "2",
                "STATUS_CODE_PORTING_STARTED": "1"
            },
            "URLS": {
                "cancelPortingRequestUrl": "\/\/" + hfHost + "\/content\/cancelPortingRequestUrl",
                "removeFaxLineUrl": "\/\/" + hfHost + "\/content\/removeFaxLine",
                "updateFaxLinePermissionsUrl": "\/\/" + hfHost + "\/home\/updateFaxLinePermissions",
                "checkPortabilityStatusUrl": "\/\/" + hfHost + "\/content\/checkPortabilityStatus",
                "testUrl": "\/\/" + hfHost + "\/home\/manage",
                "spinnerUrl": "\/\/" + cdnHost + "\/images\/loading-spinner-16.gif"
            }
        },
        "URLS": {
            "cancelPortingRequestUrl": "\/\/" + hfHost + "\/content\/cancelPortingRequestUrl",
            "removeFaxLineUrl": "\/\/" + hfHost + "\/content\/removeFaxLine",
            "updateFaxLinePermissionsUrl": "\/\/" + hfHost + "\/home\/updateFaxLinePermissions",
            "checkPortabilityStatusUrl": "\/\/" + hfHost + "\/content\/checkPortabilityStatus",
            "testUrl": "\/\/" + hfHost + "\/home\/manage",
            "spinnerUrl": "\/\/" + cdnHost + "\/\/images\/loading-spinner-16.gif"
        },
        "api_pricing": {
            "URLS": {
                "contactUsUrl": "mailto:apisupport@hellosign.com",
                "salesUrl": "mailto:sales@hellosign.com"
            }
        },
        "enterpriseFeatures": {
            "HIPAA": "HIPAA"
        }
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/config.js
 ** module id = 397
 ** module chunks = 0
 **/